import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import { devConfig } from 'config/config'; // Import development configuration

/**
 * Class representing the leagues management view.
 * @extends JetView
 */
export default class leaguesManagement extends JetView {
    /**
     * Configures the layout of the leagues management view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        return {
            type: 'wide',
            cols: [
                {
                    type: 'wide',
                    localId: 'inner:layout', // Local ID for inner layout
                    rows: [
                        {
                            view: 'toolbar', // Toolbar component
                            css: theme, // Apply theme CSS
                            elements: [
                                {
                                    css: 'user-selected', // CSS class for the label
                                    view: 'label', // Label component
                                    id: 'lblTittle', // ID for the label
                                    align: 'center', // Center alignment
                                },
                            ],
                        },
                        {
                            view: 'tabbar', // Tabbar component
                            localId: 'tabbar', // Local ID for tabbar
                            id: 'menu', // ID for the tabbar
                            height: 35, // Height of the tabbar
                            options: [
                                // Tab options
                                {
                                    id: 'leagues.information', // ID for the information tab
                                    value: _('Información'), // Localized value
                                },
                                {
                                    id: 'leagues.reports/leagues.reports.userAfilliatesReport', // ID for the reports tab
                                    value: _('Reportes'), // Localized value
                                },
                                {
                                    id: 'leagues.statistics', // ID for the statistics tab
                                    value: _('Resultados'), // Localized value
                                },
                                {
                                    id: 'leagues.configuration/leagues.configuration.securityChanges', // ID for the configuration tab
                                    value: _('Configuración'), // Localized value
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subviews
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the leagues management view.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use menu plugin with tabbar
        const cur_user = this.getParam('league', true); // Get current league parameter
        webix
            .ajax() // AJAX request to fetch league data
            .get(
                devConfig.geturlApi() + 'League/GetLeagueById', // API endpoint
                'id=' + cur_user, // Query parameter
                {
                    error: function (text, data, XmlHttpRequest) {
                        // Error handling
                        webix.message('Error! '); // Display error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        // Success handling
                        data = JSON.parse(text); // Parse response data
                        $$('lblTittle').setValue(
                            // Set label value with league name
                            "<div class='username-active'><span class='icon-user'></span><div style='font-weight: normal'>Liga: &nbsp;</div><div>" +
                                data[0].Name + // League name from response
                                '</div></div>',
                        );
                    },
                },
            );
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Set user parameter
        );
    }
}

// FILE DOCUMENTED
